import React, { useEffect } from "react";
import { useContent } from "../hooks/useContent";
import axiosClient from "../configs/axios-client";

import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import { Carousel } from "antd";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NewsDetails = () => {
  // ----------- hooks ------------
  const { id } = useParams();
  const [data, setData] = React.useState({});
  const { i18n } = useTranslation()

  // ----------- side effect ------------
  useEffect(() => {
    axiosClient.get(`news/${id}`).then(res => {
      setData(res.data.data)
    })
  }, [i18n.language]);

  console.log(data);

  return (
    <>
    <Header pagetitle={"News"}/>
      <div className="flex flex-col items-center  pb-24" style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
        <div className="w-full  md:w-9/12 rounded-xl overflow-hidden px-4 pt-14">
          <Carousel autoplay >
            {[
              data.special_image,
              data.image2,
              data.image3,
              data.image4,
              data.image5,
              data.image6,
            ]
              .filter((item) => {
                return item && item.length;
              })
              .map((item) => {
                return (
                  <div
                    key={item}
                    className="carousal-img bg-black min-h-[350px] "
                  >
                    <img
                      src={item}
                      className="rounded-xl min-h-[350px] object-cover max-h-[450px] w-full"
                      alt="hag"
                    />
                  </div>
                );
              })}
          </Carousel>
          <div className={`flex flex-wrap  flex-col py-8 self-center md:self-start${i18n.language === 'ar' ? 'rtl': 'ltr'}`} style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
            <h1 className="font-semibold text-3xl md:text-4xl  text-purple mt-14 w-full">
              {data.title}
            </h1>
          <h4 className="font-medium text-lg md:text-2xl self-start  mt-14 text-slate-600  ">
            {data.content}
          </h4>
          <h4 className="font-medium text-lg md:text-2xl self-start  mt-14 text-slate-600  ">
            {data.special_content}
          </h4>
          </div>
        </div>
        <div className={`text-right px-4  max-w-[100ch] sm:max-w-4xl${i18n.language === 'ar' ? 'rtl': 'ltr'}`} style={{textAlign: i18n.language === 'ar' ? 'right': 'left',direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewsDetails;
